import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import { setupI18n } from './i18n.js'


(async function(){
    var locale = "de";
    if(window.location.href.includes("/en/")){
        locale = "en";
    }
    const app = createApp(App);
    app.use(await setupI18n(locale));
    app.mount('#atlas-app');
})();